import { render } from "./PageHasilTesKognitif.vue?vue&type=template&id=8ecb1fd6"
import script from "./PageHasilTesKognitif.vue?vue&type=script&lang=js"
export * from "./PageHasilTesKognitif.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__